import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import api from '../api';

// Image path in public folder
const footerBg = '/images/banner/bannerf.jpg';

const Footer = ({ setting }) => {
  const [metaData, setMetaData] = useState({});
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (setting && setting.length > 0) {
      const meta = {};
      setting.forEach((item) => {
        if (item.type === "footer_logo_path") meta.footer_logo_path = item.value;
        if (item.type === "website_name") meta.website_name = item.value;
        if (item.type === "about_us_description") meta.about_us_description = item.value;
        if (item.type === "facebook_link") meta.facebook_link = item.value;
        if (item.type === "twitter_link") meta.twitter_link = item.value;
        if (item.type === "instagram_link") meta.instagram_link = item.value;
        if (item.type === "linkedin_link") meta.linkedin_link = item.value;
        if (item.type === "copyright_text") meta.copyright_text = item.value;
        if (item.type === "contact_phone") meta.contact_phone = item.value;
      });
      setMetaData(meta);
    }
  }, [setting]);

  const footerLinks = [
    {
      title: "ABOUT US",
      links: [
        { label: "About", path: "/about-us" },
        { label: "Products", path: "/products" },
        { label: "Services", path: "/" },
        { label: "Contact Us", path: "/contact-us" },

      ],
    },
    {
      title: "QUICK LINKS",
      links: [
        { label: "Privacy policy", path: "/privacy-policy" },
        { label: "FAQ's", path: "/faqs" },
      ],
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/subscriber-add', { email });
      if (response.data && response.data.result) {
        toast.success(response.data.message);
        setEmail('');
      } else {
        toast.error(response.data.message || "An error occurred.");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "An error occurred. Please try again.");
    }
    setLoading(false);
  };

  return (
    <footer
      className="elly-footer-main"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(35,36,37,0) 75%, rgba(35,36,37,0)), url(${footerBg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        minHeight: '300px'
      }}
    >
      <div className="elly-footer-top">
        <div className="container px-2 px-md-4 mt-2">

          <div className="row py-1">

            {/* LEFT: Logo, About, Phone with Mobile Icon, Social below input */}
            <div className="col-12 col-md-3 mb-4 mb-md-0 text-center text-md-start d-flex flex-column align-items-center align-items-md-start">
              {/* Logo */}
              <Link to="/" className="custom-logo-link mb-3">
                <span className="custom-header-logo fw-bold fs-4 text-white">
                  {metaData.website_name}
                </span>
              </Link>

              {/* About Section */}
              {metaData.about_us_description && (
                <div
                  className="elly-footer-about text-white small mb-3 text-center text-md-start"
                  dangerouslySetInnerHTML={{ __html: metaData.about_us_description }}
                />
              )}

              {/* Phone Numbers */}
              <div className="w-100 d-flex flex-column gap-2 mt-2 d-none d-md-flex">
                {metaData.contact_phone && (
                  <div className="elly-footer-phone d-flex align-items-center me-4">
                    <span
                      className="elly-footer-phone-icon"
                      style={{ fontSize: 20, marginRight: 8 }}
                    >
                      <i className="fas fa-phone-alt"></i>
                    </span>
                    <a
                      href={`tel:${metaData.contact_phone}`}
                      className="elly-footer-phone-number"
                      style={{ color: "#fff", textDecoration: "none" }}
                    >
                      {"+91 " + metaData.contact_phone}
                    </a>
                  </div>
                )}
                <div className="elly-footer-phone d-flex align-items-center">
                  <span
                    className="elly-footer-phone-icon"
                    style={{ fontSize: 20, marginRight: 8 }}
                  >
                    <i className="fas fa-phone-alt"></i>
                  </span>
                  <a
                    href="tel:+919313007340"
                    className="elly-footer-phone-number"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    +91 93130 07340
                  </a>
                </div>
              </div>
            </div>


            {/* MIDDLE: Navigation columns */}

            <div className='col-12 col-lg-6 d-flex mb-0'>
              {footerLinks.map((col, i) => (
                <div key={i} className="col-6 col-md-3 mb-4 mb-md-0">
                  <div className="elly-footer-widget">
                    <h5 className="elly-footer-title">{col.title}</h5>
                    <ul className="elly-footer-links list-unstyled">
                      {col.links.map((l, idx) => (
                        <li key={idx}><Link to={l.path}>{l.label}</Link></li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>


            <div className="d-flex justify-content-center d-lg-none flex-wrap">
              {metaData.contact_phone && (
                <div className="elly-footer-phone d-flex align-items-center me-4">
                  <span
                    className="elly-footer-phone-icon"
                    style={{ fontSize: 20, marginRight: 8 }}
                  >
                    <i className="fas fa-phone-alt"></i>
                  </span>
                  <a
                    href={`tel:${metaData.contact_phone}`}
                    className="elly-footer-phone-number"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    {metaData.contact_phone}
                  </a>
                </div>
              )}
              <div className="elly-footer-phone d-flex align-items-center">
                <span
                  className="elly-footer-phone-icon"
                  style={{ fontSize: 20, marginRight: 8 }}
                >
                  <i className="fas fa-phone-alt"></i>
                </span>
                <a
                  href="tel:+919313007340"
                  className="elly-footer-phone-number"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  +91 93130 07340
                </a>
              </div>
            </div>

            <div className="col-12 col-md-3 mb-4 mb-md-0">
              {(metaData.instagram_link || metaData.facebook_link || metaData.contact_phone) && (
                <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-center">
                  <div className="social-links-group text-md-right text-start">
                    <span className="social-title d-block mb-1">Social Links</span>
                    <div className="social-icons d-flex">
                      <div>
                        {metaData.instagram_link && (
                        <a
                          href={metaData.instagram_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="elly-footer-icon1 insta"
                          style={{ fontSize: 20, marginRight: 10 }}
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      )}

                      </div>
                      <div>
                        {metaData.facebook_link && (
                        <a
                          href={metaData.facebook_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="elly-footer-icon1 face"
                          style={{ fontSize: 20, marginRight: 10 }}
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      )}
                      </div>
                      <div>
                        {metaData.contact_phone && (
                        <a
                          href={`https://wa.me/${metaData.contact_phone}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="elly-footer-icon1 whats"
                          style={{ fontSize: 20 }}
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="elly-footer-widget mt-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.473258197073!2d77.47926199999999!3d28.4351468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cc1a4f2c1208b%3A0x31ccdab75de49592!2sELLY%20DECOR%20%7C%20Wall%20Studio%20%26%20Soft%20Furnishing%20Store!5e0!3m2!1sen!2sin!4v1756885806281!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Elly Decor Location"
                ></iframe>
              </div>
            </div>


          </div>

          <div className="row align-items-center mt-1 borderBottm">
            {/* Newsletter Form (Left) */}
            <div className="col-12 col-md-6">
              <span className="social-title d-block mb-1 fw-bold">Subscribe to our newsletter</span>
              <form
                className="elly-footer-appointment-form"
                onSubmit={handleSubmit}
                style={{ marginBottom: "16px" }}
              >
                <div className="elly-footer-input-wrap" style={{ display: "flex" }}>
                  <input
                    placeholder="Enter email"
                    type="email"
                    className="elly-footer-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    style={{ width: "100%" }}
                  />
                  <button
                    type="submit"
                    className="elly-footer-btn"
                    disabled={loading}
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Footer copyright row */}
        <div className="elly-footer-bottom">
          <div className="container px-2 px-md-4">
            <div className="elly-footer-bottom-row justify-content-between align-items-center py-3">
              <div className="elly-footer-bottom-links" style={{ color: '#fff' }}>
                <b>Elly Decor</b> is a brand managed by <b>M/s Mahalakshmi Furnishing.</b>
              </div>
              <div className="elly-footer-bottom-copy" style={{ color: '#fff' }}>
                ©️ 2025 Elly Decor. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;